import React, { useEffect, useState } from 'react'
import TestimonialBg from "../../../assets/images/courses/course_3.jpg"
import Shape5 from "../../../assets/images/shape-5.png"
import User1 from "../../../assets/images/testimonial-1.jpg"
import defaultUser from "../../../assets/images/defaultuser2.png"
import User2 from "../../../assets/images/testimonial-2.jpg"
import Slider from 'react-slick'
import { axiosInstance, config } from '../config'
import Loader from "../../common/Loader";

const Testimonials = () => {

    const [Loading, setLoading] = useState(false);
    const [Reviews, setReviews] = useState([]);

    // react-slick's infinite loop clones slides to fill the visible slots, so
    // with no more reviews than slots a review appears several times. Loop and
    // autoplay only when there are more reviews than slots at that screen size.
    const loopFor = (slots) => Reviews.length > slots;

    const settings = {
        dots: false,
        fade: false,
        infinite: loopFor(2),
        speed: 3000,
        slidesToShow: 2,
        slidesToScroll: 1,
        waitForAnimate: false,
        arrows: false,
        autoplay: loopFor(2),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: loopFor(3),
                    autoplay: loopFor(3),
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: loopFor(2),
                    autoplay: loopFor(2),
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: loopFor(1),
                    autoplay: loopFor(1)
                }
            }
        ]
    };

    useEffect(() => {
        getReviews()
    }, [])

    function getReviews() {
        setLoading(true)
        axiosInstance.get(`/get-reviews`)
            .then(res => {
                setReviews(res?.data?.reviews?.filter(item => Number(item.status) === 0).reverse())
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <div>
            {Loading && <Loader />}
            <section className="testimonial-section">
                <div className="bg-layer" style={{ backgroundImage: `url(${TestimonialBg})` }}></div>
                <div className="cert-highlight"></div>
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="col-lg-4 col-md-12 col-sm-12 title-column">
                            <div className="title-inner">
                                <div className="sec-title light">
                                    <h2>What Our Learners Say</h2>
                                    <p>We're proud to have helped hundreds of learners across Leicester build confidence behind the wheel and achieve their driving goals. Here's what some of our learners have shared about their experience with Precision Driving School.</p>
                                </div>
                                <div className="rating-box">
                                    <h4>Excellent</h4>
                                    <ul className="rating clearfix">
                                        <li><i className="bi bi-star-fill"></i></li>
                                        <li><i className="bi bi-star-fill"></i></li>
                                        <li><i className="bi bi-star-fill"></i></li>
                                        <li><i className="bi bi-star-fill"></i></li>
                                        <li><i className="bi bi-star-half"></i></li>
                                    </ul>
                                </div>
                                {/* <div className="review-box">
                                    <p>Trust Score 4.5 (Based on 2,500 reviews)</p>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-12 col-sm-12 testimonial-column">
                            <div className="testimonial-content">
                                <div className="row clearfix">
                                    <Slider {...settings} >
                                        {Reviews.length > 0 && Reviews.map((item, i) => (
                                            <div className="col-lg-6 col-md-6 col-sm-12 testimonial-block">
                                                <div className="testimonil-block-one">
                                                    <div className="inner-box mx-3">
                                                        <div className="border-box"></div>
                                                        <ul className="rating clearfix">
                                                            {Array(5)
                                                                .fill(0)
                                                                .map((_, index) => (
                                                                    <li key={index}>
                                                                        {index < item.rating ? (
                                                                            <i className="bi bi-star-fill"></i> // Filled star
                                                                        ) : (
                                                                            <i className="bi bi-star"></i> // Empty star
                                                                        )}
                                                                    </li>
                                                                ))}
                                                        </ul>
                                                        <h4>{item?.title}</h4>
                                                        {/* <p>{item.description}</p> */}
                                                        <p
                                                            style={{
                                                                maxHeight: "130px",
                                                                overflowY: "auto",
                                                                paddingRight: "5px",
                                                                scrollbarWidth: "none",
                                                                msOverflowStyle: "none",
                                                            }}
                                                        >
                                                            {item.description}
                                                        </p>
                                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}} className="author-box">
                                                            <figure className="author-thumb"><img
                                                                src={item?.profile_photo_url || (item?.user?.image ? `${config.imageUrl}${item?.user?.image}` : defaultUser)}
                                                                alt={item?.name || item?.user?.name || "User"}
                                                                referrerPolicy="no-referrer"
                                                                onError={(e) => { e.target.onerror = null; e.target.src = defaultUser; }}
                                                            /></figure>
                                                            <h4 className='h-100 d-flex align-items-center'>{item?.user?.name}</h4>
                                                            {/* <h6>{item?.user?.address}</h6> */}
                                                            <h6 style={{color: 'white'}}>{item?.name}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Testimonials
